import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatMenuModule } from '@angular/material/menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatLegacyTabsModule as MatTabsModule } from '@angular/material/legacy-tabs';
import { TreoDateRangeModule } from 'tsui/@treo';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { TreoNavigationModule } from 'tsui/@treo';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { MentionModule } from 'angular-mentions';
import moment from 'moment';
import { TreoAutogrowModule } from 'tsui/@treo';
import { TreoFindByKeyPipeModule } from 'tsui/@treo';
import { TreoMessageModule } from 'tsui/@treo';
import { TreoCardModule } from 'tsui/@treo';
import { settingsRoutes } from './settings.routing';
import { SettingsComponent } from './settings.component';
import { UserSettingsComponent } from './users/users.component';
import { CustomizationsSettingsComponent } from './customizations/customizations.component';
import { GeneralSettingsComponent } from './general/general.component';
import { InviteUserComponent } from './modals/invite-user/invite-user.component';
import { AddTeamComponent } from './modals/add-team/add-team.component';
import { DropdownEditorComponent } from './components/dropdown-editor/dropdown-editor.component';
import { SortableDropdownEditorComponent } from './components/sortable-dropdown-editor/sortable-dropdown-editor.component';
import { StagesSortableDropdownEditorComponent } from './components/stages-sortable-dropdown-editor/stages-sortable-dropdown-editor.component';
import { CustomFieldDialogComponent } from './modals/custom-field-dialog/custom-field-dialog.component';
import { SettingsRolesResolver } from './settings.resolvers';
import { PipesModule } from 'app/shared/pipes/pipes.module';
import { ImportsService } from './imports/imports.service';
import { CustomFieldImportDialogComponent } from './modals/custom-field-import-dialog/custom-field-import-dialog.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatBadgeModule } from '@angular/material/badge';
import { CustomFieldDialogService } from './modals/custom-field-dialog/custom-field-dialog.service';
import { CalcCodeAIAbilityComponent } from './modals/calc-code-ai-ability/calc-code-ai-ability.component';
import { TaskApprovalComponent } from '@tasks/task-details/task-approval/task-approval.component';
import { SamlSettingsComponent } from './saml/saml.component';
import {
  TsButtonModule,
  TsInputComponent,
  TsPageComponent,
  TsPageHeaderModule,
  TSTreeMenuModule,
  TsDividerComponent,
  TSIconModule,
  TsBadgeModule,
  TsColorPopoverComponent,
  TsFlowConnectorComponent,
} from 'tsui';
import { TsSelectModule } from 'tsui/lib/ts-select/ts.select.module';
import { TsImageUploadComponent } from 'tsui/lib/ts-image-upload/ts-image-upload.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { TsSkeletonComponent } from 'tsui/lib/ts-skeleton/ts-skeleton.component';
import { AssetManagementState } from '../asset-management/state/asset-management.state';
import { NgxsModule } from '@ngxs/store';
import { ConditionalFieldStylingFormComponent } from './components/conditional-field-styling-form/conditional-field-styling-form.component';

@NgModule({
  declarations: [
    SettingsComponent,
    UserSettingsComponent,
    CustomizationsSettingsComponent,
    GeneralSettingsComponent,
    SamlSettingsComponent,
    InviteUserComponent,
    AddTeamComponent,
    DropdownEditorComponent,
    SortableDropdownEditorComponent,
    StagesSortableDropdownEditorComponent,
    CustomFieldDialogComponent,
    CustomFieldImportDialogComponent,
    CalcCodeAIAbilityComponent,
  ],
  imports: [
    RouterModule.forChild(settingsRoutes),
    NgxsModule.forFeature([AssetManagementState]),
    ScrollingModule,
    DragDropModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTabsModule,
    MatMenuModule,
    MatMomentDateModule,
    MatSnackBarModule,
    MatRadioModule,
    MatSelectModule,
    MatBadgeModule,
    MatChipsModule,
    MatProgressBarModule,
    MatIconModule,
    TreoNavigationModule,
    TreoAutogrowModule,
    MatProgressSpinnerModule,
    TreoFindByKeyPipeModule,
    TreoMessageModule,
    TreoCardModule,
    MatTableModule,
    MatDividerModule,
    MatSidenavModule,
    MatTooltipModule,
    TreoDateRangeModule,
    MentionModule,
    MatSlideToggleModule,
    MatListModule,
    PipesModule,
    SharedModule,
    TaskApprovalComponent,
    TsButtonModule,
    TSTreeMenuModule,
    TsPageComponent,
    TsPageHeaderModule,
    TsInputComponent,
    TsDividerComponent,
    TsSelectModule,
    TsImageUploadComponent,
    ColorPickerModule,
    TSIconModule,
    TsBadgeModule,
    TsDialogComponent,
    TsSkeletonComponent,
    TsColorPopoverComponent,
    TsFlowConnectorComponent,
    ConditionalFieldStylingFormComponent,
  ],
  providers: [
    SettingsRolesResolver,
    ImportsService,
    CustomFieldDialogService,
    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: moment.ISO_8601,
        },
        display: {
          dateInput: 'LL',
          monthYearLabel: 'MMM YYYY',
          dateA11yLabel: 'LL',
          monthYearA11yLabel: 'MMMM YYYY',
        },
      },
    },
  ],
})
export class SettingsModule {}
